export const modifyDesignOfActiveAccount = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const referrerURL = document.referrer;
        console.log(referrerURL);
        if ( referrerURL.includes('/pages/active-account') ) {
            const errorElement = document.querySelector('.errors');
            const errorMessageElement = Array.from(errorElement.querySelectorAll('li'));
            console.log(errorMessageElement);
            const hasError = errorMessageElement.some( element => element.textContent && element.textContent != "");
            console.log(hasError);
            const accountBox = document.querySelector('.customer-account-box');

            if ( hasError ) {
                const removeElements1 = Array.from(accountBox.querySelectorAll('.socialplus-error-banner-wrapper'));
                if ( removeElements1 ) {
                    removeElements1.forEach(element => {
                        element.style.display = 'none';
                    });
                }

                const removeElements2 = Array.from(accountBox.querySelectorAll('.socialplus-login-button-wrapper'));
                if ( removeElements2 ) {
                    removeElements2.forEach(element => {
                        element.style.display = 'none';
                    });
                }

                const removeElements3 = Array.from(accountBox.querySelectorAll('p'));
                if ( removeElements3 ) {
                    removeElements3.forEach(element => {
                        element.style.display = 'none';
                    });
                }

                const removeElements4 = Array.from(accountBox.querySelectorAll('.form-control'));
                if ( removeElements4 ) {
                    removeElements4.forEach(element => {
                        element.style.display = 'none';
                    });
                }

                const removeElements5 = Array.from(document.querySelectorAll('.c-register-button'));
                if ( removeElements5 ) {
                    removeElements5.forEach(element => {
                        element.style.display = 'none';
                    });
                }

                const main = document.querySelector('main');
                main.setAttribute('style', 'background-color: rgba(0, 0, 0, 0.2) !important;');
            }
        }
    })
}